module.exports = __webpack_public_path__ + "static/media/alert_client.35b47298.svg";